// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect, useRef, useState} from 'react';
import cn from 'classnames';
import hola_opt from 'hola_opt';
// import zutil from 'zutil';
import zerr from '/util/zerr.js';
import etask from 'zetask';
import plus_util from '/www/hola/pub/plus_util.js';
import plus_ui from '/www/hola/pub/plus_ui.js';
import {Email_field, t_email_field_ref} from '../email_field/email_field';
import {i_user_info} from 'hola_app_context';
import {i_plan} from '../../../../../hola/pub/plus/plus_types';
// @ts-ignore
import {fetch} from '/util/fetch.js';

import styles from './paypal_btn.module.less';

type t_paypal_payment_props = {
    cls?: string;
    submitting?: boolean;
    user: i_user_info;
    currency: string;
    plan: i_plan;
    on_fallback: ()=>void;
    hidden?: boolean;
    on_submit?: ()=>void;
    on_before_payment?: ()=>void;
    on_after_payment?:
        (opt: {payment_intent_id: string;}, email: string)=>void;
    disabled?: boolean;
    product_id?: string;
    is_renew_payment?: boolean;
};

function load_script(url, field, on_err){
    return etask([function(){
        const script_el = document.createElement('script');
        const continue_fn = this.continue_fn();
        script_el.onload = function(){
            continue_fn(field ? window[field] : window); };
        script_el.src = url;
        if (on_err)
            script_el.onerror = on_err;
        document.body.appendChild(script_el);
        return this.wait();
    }]);
}

export const Paypal_payment = (props: t_paypal_payment_props)=>{
    const {plan, cls, product_id, is_renew_payment} = props;
    const [paypal_form_rendered, set_paypal_form_rendered] = useState(false);
    const [error, set_error] = useState('');
    const rendering_paypal_form_ref = useRef(false);
    const sbx = !!plus_util.api.test_env;
    const env = sbx ? 'test' : 'live';
    const plan_id = env == 'test' ? plan.paypal_test_id : plan.paypal_id;
    const ref_prop = useRef({props: props});
    useEffect(()=>{
        ref_prop.current.props = props;
    }, [props]);
    useEffect(()=>{
        if (rendering_paypal_form_ref.current || paypal_form_rendered)
            return;
        rendering_paypal_form_ref.current = true;
        etask(function*(){
            this.finally(()=>{ rendering_paypal_form_ref.current = false; });
            try {
                const client_id = hola_opt.www_hola
                    .paypal[sbx ? 'test' : 'live'].client_id;
                yield plus_ui.wait_for_download_scripts();
                const paypal = yield load_script(
                    'https://www.paypal.com/sdk/js?client-id='+client_id
                    +'&vault=true&disable-funding=credit'
                    +'&intent=subscription', 'paypal',
                    ref_prop.current.props?.on_fallback);
                paypal.Buttons({
                    style: {layout: 'horizontal', label: 'pay',
                        tagline: false, size: 'responsive'},
                    onClick: (data, actions)=>{
                        console.log({data, actions});
                        const email = email_field_ref.current.get_email();
                        if (!email)
                            return actions.reject();

                        plus_util.perr({id:
                            'www_premium_payment_submit_clicked_paypal2'});
                        if (ref_prop.current.props.on_submit)
                            ref_prop.current.props.on_submit();
                        return actions.resolve();
                    },
                    createSubscription: (data, actions)=>{
                        console.log({data, actions});
                        return actions.subscription.create({
                            plan_id,
                            custom_id: email_field_ref.current.get_email(),
                            subscriber: {
                                email_address:
                                    email_field_ref.current.get_email(),
                            },
                        });
                    },
                    onApprove: (data, actions)=>etask(function*(){
                        try {
                            console.log({data, actions});
                            const subscr_id = data.subscriptionID;
                            const res = yield fetch(
                                '/users/payment/paypal_subscription', {
                                method: 'POST',
                                contentType: 'application/json',
                                body: JSON.stringify(Object.assign({}, {
                                    subscr_id,
                                    currency: props.currency,
                                    sbx,
                                    site: hola_opt.www_hola.site,
                                    email: email_field_ref.current.get_email(),
                                    plan_id,
                                    product_id, is_renew_payment,
                                }, plus_util.get_custom_opt())),
                            });
                            const email = res && res.email ||
                                email_field_ref.current.get_email();
                            plus_util.perr({id:
                                'www_premium_payment_submit_paypal2',
                                info: {
                                    hola_uid: props.user ? props.user.hola_uid
                                        : `basic/${email}`,
                                    period: plan.period,
                                    plan_id, subscr_id}});
                            props.on_after_payment(res, email);
                        } catch(e){
                            if (sbx)
                                console.error(e);
                            set_error(e.responseText);
                            plus_util.perr({id:
                                'www_premium_payment_submit_failed_paypal2',
                                info: {err: zerr.e2s(e)}});
                        }
                    }),
                    onCancel: (data, actions)=>{
                        console.log({data, actions});
                        const email = email_field_ref.current.get_email();
                        plus_util.perr({
                            id: 'www_premium_payment_paypal2_cancel',
                            info: {
                                hola_uid: ref_prop.current.props.user
                                    ? ref_prop.current.props.user.hola_uid
                                    : `basic/${email}`,
                                period: plan.period,
                                plan_id}});
                    },
                }).render('#paypal-button-container');
                set_paypal_form_rendered(true);
            } catch(e){
                if (sbx)
                    console.error(e);
                plus_util.perr({id: 'www_premium_payment_paypal2_init_err',
                    info: {err: zerr.e2s(e)}});
            }
        });
    });
    const email_field_ref = useRef<t_email_field_ref>();
    return <div
      className={cn(cls, props.hidden && styles.hidden)}>
      <div className="content">
        {!!error && <div className="error_payment_result">
          {error}
        </div>}
        <Email_field user={props.user} ref={email_field_ref}/>
        <div id="paypal-button-container"
          className="paypal-button-container"></div>
      </div>
    </div>;
};
